import { render, staticRenderFns } from "./InheritDetail.vue?vue&type=template&id=27f48e34&"
import script from "./InheritDetail.vue?vue&type=script&lang=js&"
export * from "./InheritDetail.vue?vue&type=script&lang=js&"
import style0 from "./InheritDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports